// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "rdkbuiltins/v1/rdkbuiltins.proto" (package "rdkbuiltins.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Service to provide information about published versions of viam-server
//
// This service is meant to be a non-permanent solution to support procedurally
// generated FE config builder fancy cards
//
// Some people think it would be ideal if this information lived in the registry
// and rdk builtins were treated as modules however, we have not yet solved the
// attribute-schema design problem and so are forced to work around it with apis
// like this.
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Struct } from "../../google/protobuf/struct";
/**
 * @generated from protobuf message rdkbuiltins.v1.ResourceRegistration
 */
export interface ResourceRegistration {
    /**
     * @generated from protobuf field: string api = 1;
     */
    api: string;
    /**
     * @generated from protobuf field: string model = 2;
     */
    model: string;
}
/**
 * @generated from protobuf message rdkbuiltins.v1.GetRegistrationsRequest
 */
export interface GetRegistrationsRequest {
    /**
     * @generated from protobuf field: optional string part_id = 1;
     */
    partId?: string;
}
/**
 * @generated from protobuf message rdkbuiltins.v1.GetRegistrationsResponse
 */
export interface GetRegistrationsResponse {
    /**
     * @generated from protobuf field: repeated rdkbuiltins.v1.ResourceRegistration resources = 1;
     */
    resources: ResourceRegistration[];
}
/**
 * @generated from protobuf message rdkbuiltins.v1.GetAttributeSchemaRequest
 */
export interface GetAttributeSchemaRequest {
    /**
     * @generated from protobuf field: optional string part_id = 1;
     */
    partId?: string;
    /**
     * @generated from protobuf field: rdkbuiltins.v1.ResourceRegistration registration = 2;
     */
    registration?: ResourceRegistration;
}
/**
 * @generated from protobuf message rdkbuiltins.v1.GetAttributeSchemaResponse
 */
export interface GetAttributeSchemaResponse {
    /**
     * @generated from protobuf field: google.protobuf.Struct schema = 1;
     */
    schema?: Struct;
    /**
     * this error field is used to help the FE distinguish between
     * a backend/network err (should retry) vs a malformed request (should not
     * retry)
     *
     * @generated from protobuf field: rdkbuiltins.v1.GetAttributeSchemaError error = 2;
     */
    error: GetAttributeSchemaError;
}
/**
 * Used to guide FE error handling
 *
 * @generated from protobuf enum rdkbuiltins.v1.GetAttributeSchemaError
 */
export enum GetAttributeSchemaError {
    /**
     * @generated from protobuf enum value: GET_ATTRIBUTE_SCHEMA_ERROR_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: GET_ATTRIBUTE_SCHEMA_ERROR_RESOURCE_NOT_FOUND = 1;
     */
    RESOURCE_NOT_FOUND = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class ResourceRegistration$Type extends MessageType<ResourceRegistration> {
    constructor() {
        super("rdkbuiltins.v1.ResourceRegistration", [
            { no: 1, name: "api", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "model", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message rdkbuiltins.v1.ResourceRegistration
 */
export const ResourceRegistration = new ResourceRegistration$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRegistrationsRequest$Type extends MessageType<GetRegistrationsRequest> {
    constructor() {
        super("rdkbuiltins.v1.GetRegistrationsRequest", [
            { no: 1, name: "part_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message rdkbuiltins.v1.GetRegistrationsRequest
 */
export const GetRegistrationsRequest = new GetRegistrationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetRegistrationsResponse$Type extends MessageType<GetRegistrationsResponse> {
    constructor() {
        super("rdkbuiltins.v1.GetRegistrationsResponse", [
            { no: 1, name: "resources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ResourceRegistration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message rdkbuiltins.v1.GetRegistrationsResponse
 */
export const GetRegistrationsResponse = new GetRegistrationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAttributeSchemaRequest$Type extends MessageType<GetAttributeSchemaRequest> {
    constructor() {
        super("rdkbuiltins.v1.GetAttributeSchemaRequest", [
            { no: 1, name: "part_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "registration", kind: "message", T: () => ResourceRegistration }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message rdkbuiltins.v1.GetAttributeSchemaRequest
 */
export const GetAttributeSchemaRequest = new GetAttributeSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAttributeSchemaResponse$Type extends MessageType<GetAttributeSchemaResponse> {
    constructor() {
        super("rdkbuiltins.v1.GetAttributeSchemaResponse", [
            { no: 1, name: "schema", kind: "message", T: () => Struct },
            { no: 2, name: "error", kind: "enum", T: () => ["rdkbuiltins.v1.GetAttributeSchemaError", GetAttributeSchemaError, "GET_ATTRIBUTE_SCHEMA_ERROR_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message rdkbuiltins.v1.GetAttributeSchemaResponse
 */
export const GetAttributeSchemaResponse = new GetAttributeSchemaResponse$Type();
/**
 * @generated ServiceType for protobuf service rdkbuiltins.v1.RdkBuiltinsService
 */
export const RdkBuiltinsService = new ServiceType("rdkbuiltins.v1.RdkBuiltinsService", [
    { name: "GetRegistrations", options: {}, I: GetRegistrationsRequest, O: GetRegistrationsResponse },
    { name: "GetAttributeSchema", options: {}, I: GetAttributeSchemaRequest, O: GetAttributeSchemaResponse }
]);
